import { Env } from '@Constants/BuildInfo';

export const STATIC_CONTENT_URLS_REGEX = [/^(\/)?app\/.*/, /^(\/)?cdn\/.*/, /^(\/)?extractedCss\/.*/, /^(\/)?js\/.*/];

export function isStaticContentUrl(url) {
  return STATIC_CONTENT_URLS_REGEX.some((regEx) => regEx.test(url));
}

export function updateUrlWithStaticHost(url) {
  if (url && isStaticContentUrl(url)) {
    return `${Env.StaticHostUrl.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
  }
  return url;
}
